import { Resource } from "i18next";
import t from "../../locales/vi.json";

export default t as Resource;
